export default __webpack_public_path__ + "static/media/5e797d96527457a8dc0ad2ed4ea8371d.svg";